import { useMutation } from '@tanstack/react-query';
import { logout } from '../services/auth-service';

export function useLogoutMutation() {
  return useMutation({ mutationFn: logout });
}
